export default "__VITE_ASSET__ZGLOAeCM__"